import {
  RECEIVE_USERINFO,
  GET_USER_MENU_PERMS,
  GET_OA_WAITCOUNT,
  GET_TOOLTIP_INFO,
  GET_USER_ORGS
} from "./mutation-types";

import { usergetUserInfo } from "../api/system/user";
import { getUserMenusPerms } from "../api/system/user";
import { getOAWaitCount, getOrgSelect } from '../api/utils/index'
import { getGlobalInfoMap } from '../api/system/configManage'
export default {

  // 获取并存储用户基本信息
  async getusergetUserInfo({ commit }) {
    const res = await usergetUserInfo();
    if (res.code === "000000") {
      const user = res.data;
      commit(RECEIVE_USERINFO, { user });
    }
  },
  async MenusPerms({ commit }) {
    // const menu = menuTest;
    // commit(GET_USER_MENU_PERMS,{menu})
    const { code, data } = await getUserMenusPerms()
    if (code === "000000") {
      const menu = data;
      commit(GET_USER_MENU_PERMS, { menu })
    }
  },
  async OAWaitCount({ commit }) {
    const { code, data } = await getOAWaitCount()
    if (code === "000000") {
      commit(GET_OA_WAITCOUNT, data)
    }
  },
  //获取页面提示信息列表
  getGlobalInfoList({ commit }) {
    return new Promise((resolve, reject) => {
      getGlobalInfoMap().then(res => {
        const { data } = res
        commit(GET_TOOLTIP_INFO, data)

        resolve(data)
      }).catch(err => {
        reject(err)
      })
    })

  },

   getUserOrgs({commit}) {
    return new Promise(async (resolve, reject) => {
      const {code,data,msg} = await getOrgSelect()
      if(code === '000000'){
        resolve(data)
        commit(GET_USER_ORGS,data)
      }else {
        reject(msg)
      }
    })
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js